// Simplified version of ANTLR utils for syntax checking

const QUERY_PREFIXES_TO_IGNORE_FOR_ANTLR_PARSING = ['create widget'];

export const removeComments = (queryText: string): string => {
  /* This is a pattern that contains a block comment or line comment.
   *      Explanation for block comment: https://regex101.com/r/dU5fO8/73.
   *           Note that "." does not match newline. */
  const commentPattern = /(\/\*[^*]*\*+(?:[^/*][^*]*\*+)*\/)|(--.*(\n|$))/g;

  // Instead of removing comments entirely, replace them with whitespace to preserve line positions
  return queryText.replace(commentPattern, (match) => {
    // Preserve newlines within the match
    return match.replace(/[^\n]/g, ' ');
  });
};

export const shouldIgnoreQueryForAntlrParsing = (query: string): boolean => {
  const processedQuery = removeComments(query.trim().toLowerCase());

  return QUERY_PREFIXES_TO_IGNORE_FOR_ANTLR_PARSING.some((prefix) =>
    processedQuery.startsWith(prefix),
  );
};
